
import { ExceptionService } from '../services/exception.service';
// import { DELETED_STATE_VALUE } from '@angular/animations/browser/src/render/transition_animation_engine';
import { TogetherAuctionDIPPropertyDetailsComponent } from './dip.property_details.component';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, Input, OnDestroy, OnInit, HostListener, ChangeDetectorRef } from '@angular/core';
import { TogetherDIPStageContainer, TogetherDIPStage } from './../models/app.models';
import {
  TogetherAuctionDIPApplicantDetails,
  TogetherAuctionDIPLoanDetails,
  TogetherAuctionDIPSecurityDetails,
} from './../models/api.models';
import { NodeAPIService } from './../services/node.api.service';
import { NodeAPIEntityService } from './../services/node.entity.service';
import { Title } from '@angular/platform-browser';
import * as _ from 'lodash-es';
import { DipStateService } from '../services/dip-state-service.service';
import { EntityStateService } from '../services/entity-state.service';
import { Observable } from 'rxjs';
import { TogetherAuctionDIPStageType } from './../models/enums';

@Component({
    selector: 'together-page-content-dynamic',
    templateUrl: './dip.component.html',
    providers: [NodeAPIService, NodeAPIEntityService],
    standalone: false
})
export class TogetherDIPComponent implements OnInit, OnDestroy {
  // Stage variables
  TITLE_PREFIX: string = 'Together Money - ';
  stage: TogetherDIPStageContainer = new TogetherDIPStageContainer();
  // Inputs
  _stepChangingInput: object;

  // Junk to be removed eventually.
  current_step_number: number;
  current_step: object;
  sub: any;
  _is_saved_against_api: boolean = false;
  __debug: string;

  // Route parameter information - this is passed through to the page.
  incoming_case_id: string = '00000000-0000-0000-0000-000000000000';
  property_type: string = '0';
  is_dip: boolean = true;
  totalSteps: number = 4;
  dipData: object = {
    propertyType: 0,
    caseId: '00000000-0000-0000-0000-000000000000',
    isDipJourney: true,
  };

  /**
   * The Loan details on the application.
   *
   * @type {TogetherAuctionDIPLoanDetails}
   * @memberof TogetherDIPComponent
   */
  loan_details: TogetherAuctionDIPLoanDetails = new TogetherAuctionDIPLoanDetails();

  /**
   * The property details on the application.
   *
   * @type {TogetherAuctionDIPSecurityDetails}
   * @memberof TogetherDIPComponent
   */
  property_details: TogetherAuctionDIPSecurityDetails = new TogetherAuctionDIPSecurityDetails();

  @HostListener('window:popstate', ['$event'])
  onMoveForward(event) {
    const parts = _.split(event.currentTarget.location.href, '/', 2);

    this.redirectToLogin(parts[1]);
  }

  /**
   * Applicants on the application.
   *
   * @type {Array<TogetherAuctionDIPApplicantDetails>}
   * @memberof TogetherDIPComponent
   */
  applicants: Array<TogetherAuctionDIPApplicantDetails> = [
    new TogetherAuctionDIPApplicantDetails(1),
  ];
  /**
   * All stage-meta data loaded from the DipStateService
   *
   * **TODO** this neeed to be removed and the service accessed directly
   *
   * @type {object}
   * @memberof TogetherDIPComponent
   */
  stages: object;
  _handleUpdatedCaseId(case_id) {
    this.incoming_case_id = case_id;
  }

  /**
   * Updates loan details from output of loan_details component. (_ = output handler.)
   *
   * @memberof TogetherDIPComponent
   */
  _handleUpdatedLoanDetails(loan_details) {
    this.loan_details = loan_details;
    this.incoming_case_id = loan_details.CaseId;
  }

  /**
   * Adds an applicant to the application.
   *
   * @memberof TogetherDIPComponent
   */
  _handleAddApplicant() {
    const num_apps = this.applicants.length;
    this.applicants.push(new TogetherAuctionDIPApplicantDetails(num_apps + 1));
  }

  _addApplyParameters(parameters) {
    this.property_type = parameters.property_type;
    // this.is_dip is now mananged by the sibject it is observing
    // this.is_dip = parameters.is_dip === 'true';

    // Handle the fact we'll be changing the property type
    this.getDipDataFromLocalStorage().subscribe((params: any) => {
      if (params['propertyType'] !== parameters.property_type) {
        if (_.isNil(params)) {
          return;
        }
        params['propertyType'] = parameters.property_type;
        this.initLocalStorage(params).subscribe(() => { });
      }
    });

    this.totalSteps = this.is_dip ? 4 : 6;
    this.stages['tad_stage_additional_loan_details'].currentStep = 5;
    this.stages['tad_stage_solicitors_details'].currentStep = 6;
  }

  /**
   * Deletes an applicant.
   *
   * @param {any} applicant
   * @memberof TogetherDIPComponent
   */
  deleteApplicant(applicant) {
    // Loop applicants.
    for (let i = 0; i <= this.applicants.length; i++) {
      if (this.applicants[i] === applicant) {
        delete this.applicants[i];
      }
    }
  }

  /**
   * Sets the page title
   *
   * @param {string} newTitle
   * @memberof TogetherDIPComponent
   */
  setPageTitle(newTitle: string) {
    this.titleService.setTitle(this.TITLE_PREFIX + newTitle);
  }

  /**
   * Gets the current stage (To prevent back button when already submitted)
   *
   * @returns
   * @memberof TogetherDIPComponent
   */
  getCurrentStage(): Observable<any> {
    return this.entity.getStage(this.state.CaseId);
  }

  /**
   * Moves to the info page if we're not happy with the parameters.
   *
   * @memberof TogetherDIPComponent
   */
  moveToDefaultPath() {
    if (this.stage.current_stage.reference !== 'tad_stage_login_recap') {
      this.router.navigate(['dip', 'tad_stage_login_recap', this.state.CaseId]); // Allow router to determine default.
    }
  }

  /**
   * Checks to see if the current case has been submitted.
   *
   * @memberof TogetherDIPComponent
   */
  checkIsSubmitted(): Observable<boolean> {
    const self = this;
    return new Observable((reqObs) => {
      self.getCurrentStage().subscribe((stage) => {
        reqObs.next(stage === TogetherAuctionDIPStageType.ApplicationSubmitted);
      }, (error) => {
        if (!error) {
          self.cd.reattach();
          return;
        }
        reqObs.error(error);
      });
    });
  }

  /**
   * Prevents save of if the case is submitted already.
   *
   * @memberof TogetherDIPComponent
   */
  preventSaveIfSubmitted() {
    this.cd.detach();
    const self = this;
    this.checkIsSubmitted().subscribe((isAppSubmitted) => {
      if (!isAppSubmitted) {
        self.persistStageSub();
      } else {
        this.moveStageForward();
      }
    }, (error) => self.persistStageSub());
  }

  /**
   * Redirect if submitted already, all bets are off!
   *
   * @memberof TogetherDIPComponent
   */
  redirectIfSubmitted() {
    const self = this;
    this.checkIsSubmitted().subscribe((isAppSubmitted) => {
      if (isAppSubmitted) {

        // Check the current stage.
        const currentStage = this.stage.current_stage.reference;

        // If the stage is outcome or recap, don't do it captain!
        const isPermitted = [
          'tad_stage_application_outcome',
          'tad_stage_login_recap',
        ].indexOf(currentStage) !== -1;

        // Is the stage change permitted?
        if (!isPermitted) {

          // Then move away!
          self.moveToDefaultPath();
        }
      }
    });
  }

  /**
   * Pushes stage forward.
   *
   * @memberof TogetherDIPComponent
   */
  moveStageForward() {
    this.cd.reattach();
    // Push the current stage into the state service
    this.state.currentStage.next(this.stage.current_stage);
  }

  /**
   * Moved stage persist into sub element.
   *
   * @memberof TogetherDIPComponent
   */
  persistStageSub() {
    this.moveStageForward();
    if (this.entity.isNew(this.incoming_case_id) === false) {
      const stage = this.stages[this.stage.current_stage.reference];
      let num = _.isNil(stage) ? 100 : stage.num;
      const stageName = stage['reference'];

      // If it's a submit, now we set the num to 110. (Yes, it's a HACK: boii.)
      if (stageName === 'tad_stage_application_submit') {
        num = 110;
      }

      // Now if it's in the range, then we save it.
      if (_.inRange(num, 99, 114) && stageName !== 'tad_stage_application_overview') {
        this.cd.detach();
        this.entity.setStage(this.incoming_case_id, num)
          .subscribe(
            (success) => {
              this.cd.reattach();
            },
            (error) => {
              this.exception.haveReceivedError(error);
            },
          );
      }
    }
  }

  /**
   * Saves the stage with the API.
   *
   * @memberof TogetherDIPComponent
   */
  persistStage() {
    this.moveStageForward();
    this.preventSaveIfSubmitted();
  }

  /**
   * Set this isDip flag
   * Note: this needs to happen but must be replaced to use the state service ASAP
   *
   * @param {string} stage
   * @memberof TogetherDIPComponent
   */
  setDipFlag(stage: string): void {
    if (stage === 'tad_stage_info') {
      // this.is_dip = true;
      this.state.isDipJourney.next(true);
    } else if (stage === 'tad_stage_apply') {
      // this.is_dip = false;
      this.state.isDipJourney.next(false);
    }
  }

  /**
   * When the route changes, will update the stage.
   *
   * @memberof TogetherDIPComponent
   */
  ngOnInit() {
    // Subscribe for chenges to the state service's isDipJourneyFlag
    this.state.isDipJourney.subscribe((next) => {
      this.is_dip = next;
    });
  }

  /**
   * Sets DIP Data in local storage.
   *
   * @returns {object} dipDetails The DIP details.
   * @memberof TogetherDIPComponent
   */
  getDipDataFromLocalStorage() {
    return new Observable((reqObs) => {
      reqObs.next(JSON.parse(window.sessionStorage.getItem('dipDetails')));
    });
  }

  /**
   * Initialises the localStorage data from the parameters provided.
   *
   * @memberof TogetherDIPComponent
   */
  initLocalStorage(params: object) {
    return new Observable((reqObs) => {
      window.sessionStorage.setItem('dipDetails', JSON.stringify(params));
      reqObs.next(true);
    });
  }

  /**
   * Is the local storage initialised?
   *
   * @returns
   * @memberof TogetherDIPComponent
   */
  isLocalStorageInit() {
    return new Observable((reqObs) => {
      this.getDipDataFromLocalStorage().subscribe((success) => {
        reqObs.next(!_.isNil(success));
      }, (error) => {
        reqObs.error(error);
      }, () => {
        reqObs.complete();
      });
    });
  }

  /**
   * Clears the local storage if tampered.
   *
   * @memberof TogetherDIPComponent
   */
  deleteLocalStorage() {
    window.sessionStorage.clear();
  }

  /**
   * Is the parameter tampered?
   *
   * @memberof TogetherDIPComponent
   */
  isParamTampered(incomingValues: object, storedValues: object) {
    const incoming = `${incomingValues['caseId']}${incomingValues['propertyType']}${incomingValues['isDipJourney']}`;
    const stored = `${storedValues['caseId']}${storedValues['propertyType']}${storedValues['isDipJourney']}`;
    return incoming !== stored;
  }

  /**
   * Check for parameter tampering.
   *
   * @param {object} params
   * @memberof TogetherDIPComponent
   */
  checkParameterTampering(
    params: { caseId: string, propertyType: number, isDipJourney: boolean }):
    Observable<{ isTampered: boolean, isExistingCase: boolean }> {

    // Get a new observable out as the route change needs to subscribe.
    return new Observable((reqObs) => {

      // Cache the params so it's available here.
      const cacheParams = params;

      // Get the caseId
      const { caseId } = params;

      // Get the values from localstorage, subscribe to observable.
      const dipValues = this.getDipDataFromLocalStorage().subscribe((param: any) => {

        // Get the stored Case Id.
        const storedCaseId = _.defaultTo(param['caseId'], '');

        if (storedCaseId === caseId) {
          reqObs.next({
            isTampered: false,
            isExistingCase: true,
          });
        } else if (storedCaseId === '00000000-0000-0000-0000-000000000000' &&
          caseId !== '00000000-0000-0000-0000-000000000000') {
          this.initLocalStorage(cacheParams).subscribe(() => { });
          reqObs.next({
            isTampered: false,
            isExistingCase: true,
          });
        } else if (this.isParamTampered(params, param)) {

          // Now delete local storage.
          this.deleteLocalStorage();

          // So, the parameter tampering is complete - they did tamper, so end.
          reqObs.next({
            isTampered: true,
            isExistingCase: false,
          });
        } else {
          this.initLocalStorage(cacheParams).subscribe(() => { });
          reqObs.next({
            isTampered: false,
            isExistingCase: false,
          });
        }

        // Either way, now it's complete.
        reqObs.complete();
      }, (error) => {
        reqObs.error(error);
      }, () => {
        reqObs.complete();
      });
    });
  }

  /**
   * Route the page from params.
   *
   * @memberof TogetherDIPComponent
   */
  routeFromParams(stageName, caseId, propertyType, isDip) {
    if (stageName === 'tad_stage_login') {
      this.redirectToLogin(stageName);
      return;
    }

    // Otherwise route to regular stuff.
    this.router.navigate(['dip', stageName, caseId, propertyType, isDip]);
  }

  /**
   * Determine what the current stage is.
   *
   * @memberof TogetherDIPComponent
   */
  determineCurrentStage(
    params: {
      stageName: any,
      isDipJourney: boolean,
      caseId: any,
      propertyType: number,
    },
    isExistingCase: boolean = false,
  ) {

    // Get the stage name
    const { stageName, isDipJourney, caseId, propertyType } = params;

    // Create the stage container.
    const stageContainer = new TogetherDIPStageContainer();

    // Set the number of steps
    if (!isDipJourney) {
      this.totalSteps = 6;
      this.stages['tad_stage_additional_loan_details'].currentStep;
      this.stages['tad_stage_solicitors_details'].currentStep = 6;
    } else {
      if (stageName === 'tad_stage_additional_loan_details'
        || stageName === 'tad_stage_solicitor_details') {
        this.totalSteps = 2;
      }
    }

    // Get the current state.
    const currentStage: TogetherDIPStage = this.stages[stageName];

    // Get the current stage from the stages, to get the stage info.
    if (_.isNil(stageName) || _.isNil(currentStage)) {
      this.state.reset();
      return this.router.navigate(['dip',
        currentStage['reference'],
        this.state.caseId.getValue(),
        this.state.propertyType.getValue(),
        this.state.isDipJourney.getValue(),
      ]);
    }

    // Get the references from the stage.
    const forwardStageName = currentStage.forward_reference;
    const backwardStageName = currentStage.backward_reference;

    // Get the forward stage
    const forwardStage: TogetherDIPStage =
      _.defaultTo(this.stages[forwardStageName], this.stages['tad_stage_info']);

    // Get the backward stage
    const backwardStage: TogetherDIPStage =
      _.defaultTo(this.stages[backwardStageName], this.stages['tad_stage_info']);

    // Set the stageContainer
    stageContainer.current_stage = currentStage;
    stageContainer.backward_stage = backwardStage;
    stageContainer.forward_stage = forwardStage;

    // Set the stage.
    this.stage = stageContainer;

    // Persist the stage.
    this.persistStage();

    // Create page title.
    const pageTitle = stageName === 'tad_stage_login_recap' ?
      `Your ${isDipJourney ? 'Decision in Principle' : 'Loan Application'}` :
      currentStage.page_title;

    // Set the title
    this.setPageTitle(pageTitle);

    // Set the DIP flag.
    this.setDipFlag(stageName);

    // Route the page from the paremeters.
    if (isExistingCase) {
      this.routeFromParams(stageName, caseId, propertyType, isDipJourney);
    }
  }

  /**
   * Sets the stage when navigating between stages.
   *
   * @param {any} stage_name
   * @memberof TogetherDIPComponent
   */
  setStage(stage_name) {
    let stage = stage_name;
    this.stage = new TogetherDIPStageContainer();

    if (!_.isNil(this.stages[stage])) {
      this.stage.current_stage = this.stages[stage];
    } else {
      this.stage.current_stage = this.stages['tad_stage_apply'];
      stage = 'tad_stage_apply';

      // Kill the state to prevent a bad URL from messing up the current case step
      this.state.reset();
      // New re-direct to reset the URL before things go... odd...
      return this.router.navigate(['dip',
        this.stage.current_stage['reference'],
        this.state.caseId.getValue(),
        this.state.propertyType.getValue(),
        this.state.isDipJourney.getValue(),
      ]);

    }

    // Get the forward and backward stages from the object.
    const forward_stage_name = this.stages[stage].forward_reference,
      backward_stage_name = this.stages[stage].backward_reference;

    const forward_stage = _.isNil(forward_stage_name) ? this.stages['tad_stage_info'] : this.stages[forward_stage_name],
      backward_stage = _.isNil(backward_stage_name) ? this.stages['tad_stage_info'] : this.stages[backward_stage_name];

    // Set the forward and backward stages.
    this.stage.forward_stage = forward_stage;
    this.stage.backward_stage = backward_stage;
    this.persistStage();

    this.setPageTitle(this.stage.current_stage.page_title);
    // A hideous hack but will have to *TODO* for now
    if (this.stage.current_stage['reference'] === 'tad_stage_login_recap') {
      const appType = this.is_dip ? 'Decision in Principle' : 'Loan Application';
      this.setPageTitle(`Your ${appType}`);
    }

    // if(_.isNil(this.property_type) == false && _.isNil(this.is_dip) == false) {

    this.setDipFlag(this.stage.current_stage['reference']);
    if (this.stage.current_stage['reference'] === 'tad_stage_login') {
      this.router.navigate(['dip', this.stage.current_stage['reference']]);
    } else {
      this.router.navigate(['dip', this.stage.current_stage['reference'], this.incoming_case_id, this.property_type, this.is_dip]);
      /*} else {
        this.router.navigate(['dip', this.stage.current_stage['reference'], this.incoming_case_id]);
      }*/
    }
  }

  /**
   * Update the state service.
   *
   * @memberof TogetherDIPComponent
   */
  updateStateService(params) {
    this.state.propertyType.next(params['propertyType']);
    this.state.isDipJourney.next(params['isDipJourney']);
    this.state.caseId.next(params['caseId']);
    this.state.currentStage.next(this.stage.current_stage);
    this.incoming_case_id = params['caseId'];
  }

  /**
   * Subscribe to changes in the router.
   *
   * @memberof TogetherDIPComponent
   */
  subscribeToRouteChanges() {
    this.route.params.subscribe((routeChange) => {
      // If it's submitted, biff it off.
      this.redirectIfSubmitted();

      // Get the params from the route as variables so we can manipulate them.
      let { propertyType, isDipJourney, caseId } = routeChange;
      const { stageName } = routeChange;

      // Default DIP journey as some don't require these params.
      isDipJourney = isDipJourney || 'true';

      // This is to prevent application route orm cacking out
      if (stageName === 'tad_stage_apply') {
        isDipJourney = 'false';
      }
      propertyType = propertyType || 0;
      caseId =
        _.defaultTo(caseId === '' ? null : caseId, '00000000-0000-0000-0000-000000000000');

      // Let's create the params to match to.
      const params = {
        caseId,
        stageName,
        propertyType: _.toInteger(propertyType),
        isDipJourney: isDipJourney === 'true',
      };

      if (stageName === 'do_retrieve_case') {
        this.determineCurrentStage(params);
        return;
      }

      // Don't set params if it's login page.
      if (stageName === 'tad_stage_login') {
        this.deleteLocalStorage();
        const container = new TogetherDIPStageContainer();
        container.backward_stage = this.stages['tad_stage_login'];
        container.current_stage = this.stages['tad_stage_login'];
        container.forward_stage = this.stages['tad_stage_login_recap'];
        this.stage = container;
        this.persistStage();
        this.setPageTitle(container.current_stage.page_title);
        return;
      }

      if (stageName === 'tad_stage_info' || stageName === 'tad_stage_apply') {
        params.caseId = '00000000-0000-0000-0000-000000000000';
        this.deleteLocalStorage();
      }

      // If the local storage is initialised, do stuff.
      this.isLocalStorageInit().subscribe((isInit) => {

        if (!isInit) {
          // If the ID is not empty and no storage, kick to navigation.
          // unless it's info or apply which will be handled as new pages below
          if (caseId !== '00000000-0000-0000-0000-000000000000') {
            this.redirectToLogin(stageName, true);
            return;
          }

          // Set the local storage with the params.
          this.initLocalStorage(params).subscribe((success) => { });

          // Do nothing more, the local storage was just initialised.
          this.determineCurrentStage(params);

          // If at one of the start pages with no storage initialised redirect
          if (stageName === 'tad_stage_info' || stageName === 'tad_stage_apply') {
            params.caseId = '00000000-0000-0000-0000-000000000000';
            this.router.navigate(['dip',
              stageName,
              params.caseId,
              params.propertyType,
              params.isDipJourney,
            ]);
          }
        }

        this.updateStateService(params);

        // Check for parameter tampering.
        this.checkParameterTampering(params).subscribe((tampered) => {

          // Is the case tampered / existing case?
          const { isTampered, isExistingCase } = tampered;

          // If they tampered with it, redirect to login. (Localstorage already nuked.)
          if (isTampered) {
            this.redirectToLogin(stageName);
            this.determineCurrentStage(params, false);
          } else {
            // They didn't, so now set the stage.
            this.determineCurrentStage(params, isExistingCase);
          }
        });
      });
    });
  }

  /**
   * Handle redirection to login except for stage pages
   *
   * @private
   * @param {string} stageIn The stage to be redirected from
   * @memberof TogetherDIPComponent
   */
  private redirectToLogin(stageIn: string, force: boolean = false): void {
    const stage = _.defaultTo(stageIn, '');
    if ((stage !== 'tad_stage_info'
      && stage !== 'tad_stage_apply'
      && stage !== 'tad_stage_login') || force) {
      this.router.navigate(['dip', 'tad_stage_login']);
    }
  }
  ngOnDestroy() {

  }
  /**
   * Creates an instance of TogetherDIPComponent.
   * @param {Router} router
   * @param {ActivatedRoute} route
   * @param {NodeAPIService} api
   * @memberof TogetherDIPComponent
   */
  constructor(
    private titleService: Title,
    private router: Router,
    private route: ActivatedRoute,
    private api: NodeAPIService,
    private entity: NodeAPIEntityService,
    private state: DipStateService,
    private entityState: EntityStateService,
    private cd: ChangeDetectorRef,
    private exception: ExceptionService) {
    this.stages = state.allStages;
    this.dipData = this.getDipDataFromLocalStorage();
    this.subscribeToRouteChanges();
  }
}
